module.exports = __webpack_public_path__ + "img/repair.71c6fc9c.png";